import { render } from "./MDBFile.vue?vue&type=template&id=7017d96d"
import script from "./MDBFile.vue?vue&type=script&lang=js"
export * from "./MDBFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/repos/MDB/VUE/Release/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__